export const cardMediaTextSize = {
  grid: {
    title: "titleExtraLarge",
    description: "bodySmall",
  },
  card: {
    title: "titleMedium",
    description: "bodySmall",
  },
  inline: {
    title: "titleSmall",
    description: "bodySmall",
  },
};
